import React, { useEffect, useState } from "react";
import { CommonListType, useCommonListWrap } from "../../../hooks/useCommonList/useCommonListWrap";
import Location from "../../../../models/Location";
import {
	getDetailDestinations,
	getListDestinations,
	getRecommendLocation,
	getTopDestinations,
	offlineGetDetailDestination,
} from "../../../../services/LocationService";
import { withSsrRawDataMulti } from "../../../controls/common/StaticContextWrap";
import useStaticContext from "../../../hooks/useStaticContext";
import { EmailKeyword, getEmailKeywork, updateContentEmail } from "../../../../services/EmailSerivce";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";

export default function useUpdateContentEmail(props: { setOpenDialog: (value: boolean) => void }) {
	const { openAlertDialog } = useAlertDialog();
	const loadUpdate = async (id: number, content: string, name?: string, subject?: string) => {
		try {
			await updateContentEmail(id, content, name, subject);
			openAlertDialog?.(AlertType.Success, "Thay đổi thành công!", () => {
				props.setOpenDialog(false);
			});
			return true;
		} catch (error) {
			console.error(error);
			openAlertDialog?.(AlertType.Fail, "Không thể cập nhật template email.");
			return false;
		}
	};
	return {
		loadUpdate,
	};
}
